import { RqmtTestList } from '@/ac/entities/rqmtTest/RqmtTestList';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useEffect } from 'react';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '../../../common/entityFramework/entityForm/EntityForm';
import { TestResultsTab } from './TestResultsTab';

export const TestDetail = () => {
  const { entityObj, setBreadcrumbs } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'rqmtsTab',
      label: 'Requirements',
      content: <RqmtTestList testId={entityObj.id} />,
    },
    {
      id: 'testResTab',
      label: 'Results',
      content: <TestResultsTab testId={entityObj.id} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="TEST" parentEntityId={entityObj.id} />,
    },
  ];

  const run = useCallback(() => {
    const rowsReq = { expr: ExprUtils.whereParams('code', entityObj.code) };
    rsrc.one('skdr', 'JOB', rowsReq).then((job) => {
      if (job) {
        rsrc.start(job.id);
      }
    });
  }, [entityObj.code]);

  const augButtons = (buttons) => {
    buttons.push(<TitleButton icon={fas.faPlay} toolTip="Run Test" onClick={run} />);
  };

  useEffect(() => {
    if (!entityObj || entityObj.id == null) return;
    const breadCrumb = entityObj.code.replace('_', '-') + ': ' + entityObj.name;
    setBreadcrumbs([breadCrumb]);
  }, [entityObj]);

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
